import { useState, useEffect, useRef } from 'react';

import palette from '@lib/core/src/theme/palette';
import { Drawer } from '@mui/material';

import { HEADER_HEIGHT } from '@/components/Header/HeaderStyles';
import InviteJourneyAiModal from '@/components/modals/InviteJourneyAi/InviteJourneyAiModal';
import { useIsSidebarOpen, useSidebarActions } from '@/store/sidebarStore';
import { useIsSmallScreen } from '@/utils/mediaUtil';

import SidebarMenu from './SidebarMenu';
import { SIDEBAR_WIDTH, SidebarScrollContent, UserDetailsWrapper } from './SidebarStyles';
import SidebarThreads from './SidebarThreads';
import UserDetails from './UserDetails';

const Sidebar = () => {
  const isSidebarOpen = useIsSidebarOpen();
  const isSmallScreen = useIsSmallScreen();
  const [isModalOpen, setModalOpen] = useState(false);
  const { hideSidebar, showSidebar } = useSidebarActions();
  const sidebarScrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isSmallScreen) {
      hideSidebar();
    } else {
      showSidebar();
    }
  }, [isSmallScreen, showSidebar, hideSidebar]);

  return (
    isSidebarOpen && (
      <Drawer
        open={true}
        onClose={() => {
          if (isSmallScreen) {
            hideSidebar();
          }
        }}
        anchor="left"
        variant={isSmallScreen ? 'temporary' : 'persistent'}
        slotProps={{
          paper: {
            sx: {
              backgroundColor: palette.globalBackground,
              width: isSmallScreen ? '65%' : SIDEBAR_WIDTH,
              borderLeft: { lg: `1px solid ${palette.grey[1200]}` },
              paddingTop: '2vh',
              top: HEADER_HEIGHT,
              height: `calc(100% - ${HEADER_HEIGHT})`
            }
          },
          backdrop: {
            sx: {
              backdropFilter: 'blur(10px)'
            }
          }
        }}
      >
        <SidebarScrollContent ref={sidebarScrollRef}>
          <SidebarMenu />
          <InviteJourneyAiModal open={isModalOpen} onClose={() => setModalOpen(false)} />
          <SidebarThreads scrollRef={sidebarScrollRef} />
        </SidebarScrollContent>
        <UserDetailsWrapper>
          <UserDetails />
        </UserDetailsWrapper>
      </Drawer>
    )
  );
};

export default Sidebar;
